import React from "react";
import {
  Container,
  Item,
  SubTitle,
  SubValue,
  Title,
  ItemNote,
} from "./styles/style";
import { formatnumber } from "src/utils/formatnumber";
import { useCustomInvestments } from "src/store/hooks/useInvestements";
import { colors } from "src/theme/colors";
import BalanceStats from "src/components/Modals/CashFlows/BalanceStats";

export const Details = ({
  current,
  deposit,
  /**
   * The dialog's form of the same three readings: a strip of stats rather
   * than a column beside the form, since a dialog cannot spare a third of
   * its width for three figures.
   */
  asDialog,
}: {
  current?: number;
  deposit?: number;
  asDialog?: boolean;
}) => {
  const { data, isFetching } = useCustomInvestments();
  const cash = Number(data?.totalCash ?? 0);
  const adding = Number(deposit ?? 0);
  const money = (value: number) =>
    formatnumber(value, { min: 0, max: 0, prefix: "$" });

  /* The same figures, the same rounding, the same wording — laid across the
     dialog instead of down its side, and told when they are being
     refreshed. */
  if (asDialog)
    return (
      <BalanceStats
        updating={isFetching && Boolean(data?.totalCash)}
        /* Only what is true. With no bank account on file there is no amount
           to deposit and the amount field is not even shown, yet the strip
           went on promising "+$5,000" and a new balance to match — a figure
           for a transfer that cannot be started. */
        readings={
          adding > 0
            ? [
                { label: "Current", value: money(cash) },
                { label: "Depositing", value: `+${money(adding)}` },
                { label: "New balance", value: money(cash + adding) },
              ]
            : [{ label: "Current balance", value: money(cash) }]
        }
      />
    );

  return (
    <Container>
      <Title>Account balance</Title>

      <Item>
        <SubTitle>Current</SubTitle>
        <SubValue>
          {formatnumber(cash, { min: 0, max: 0, prefix: "$" })}
        </SubValue>
      </Item>

      {/* Signed, because it is the term being ADDED — the one figure of the
          three that the form is changing. */}
      <Item>
        <SubTitle>Depositing</SubTitle>
        <SubValue $tone={colors.primary[600]}>
          +{formatnumber(adding, { min: 0, max: 0, prefix: "$" })}
        </SubValue>
      </Item>

      <Item $total>
        <SubTitle>New balance</SubTitle>
        <SubValue $total>
          {formatnumber(cash + adding, { min: 0, max: 0, prefix: "$" })}
        </SubValue>
      </Item>
    </Container>
  );
};
